(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1920],{

/***/ 84344:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/study-abroad-association",
      function () {
        return __webpack_require__(76574);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ study_abroad_association; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
// EXTERNAL MODULE: ./styles/partnerServices.module.scss
var partnerServices_module = __webpack_require__(52783);
var partnerServices_module_default = /*#__PURE__*/__webpack_require__.n(partnerServices_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Recognition.tsx
var Recognition = __webpack_require__(79767);
// EXTERNAL MODULE: ./components/FeaturedBlogs.tsx
var FeaturedBlogs = __webpack_require__(85684);
// EXTERNAL MODULE: ./components/Testimonial.tsx
var Testimonial = __webpack_require__(537);
// EXTERNAL MODULE: ./components/UniTieUp.tsx
var UniTieUp = __webpack_require__(97761);
// EXTERNAL MODULE: ./components/kcNewlatestupdates.tsx
var kcNewlatestupdates = __webpack_require__(79465);
// EXTERNAL MODULE: ./components/FeaturedPartnerWebinars.tsx
var FeaturedPartnerWebinars = __webpack_require__(97736);
// EXTERNAL MODULE: ./components/PST/FrequentlyAskedQuestions.tsx
var FrequentlyAskedQuestions = __webpack_require__(3011);
// EXTERNAL MODULE: ./components/PST/VideoTestimonials.tsx
var VideoTestimonials = __webpack_require__(55689);
// EXTERNAL MODULE: ./components/CfAppBanner/CfAppBanner.module.scss
var CfAppBanner_module = __webpack_require__(62154);
var CfAppBanner_module_default = /*#__PURE__*/__webpack_require__.n(CfAppBanner_module);
;// CONCATENATED MODULE: ./components/CfAppBanner/CfAppBanner.tsx





const CfAppBanner = ()=>{
    const ref = (0,react.useRef)(null);
    const { 0: initialBannerClick , 1: setInitialBannerClick  } = (0,react.useState)(true);
    const handleButtonClick = ()=>{
        ref?.current?.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
        if (initialBannerClick) {
            setTimeout(()=>{
                ref?.current?.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }, 600);
            setInitialBannerClick(false);
        }
    };
    const stickyAppBanner = ()=>{
        const element = document.createElement("div");
        element.classList.add((CfAppBanner_module_default()).stickyAppBanner);
        element.id = "sticky-app-banner";
        element.innerHTML = `<span>Download coursefinder app</span><img src='https://assets.studies-overseas.com/cancel_fc437b3795.svg'  id='close-sticky-app-banner'>`;
        element.addEventListener("click", handleButtonClick);
        return element;
    };
    const removeStickyAppBanner = (e)=>{
        e.stopPropagation();
        const stickyAppBannerElement = document.getElementById("sticky-app-banner");
        if (stickyAppBannerElement) {
            stickyAppBannerElement.remove();
        }
    };
    (0,react.useEffect)(()=>{
        if (window !== undefined) {
            const element = stickyAppBanner();
            const header = document.getElementById("header-navbar");
            header?.parentElement?.prepend(element);
            const closeStickyAppBanner = document.getElementById("close-sticky-app-banner");
            closeStickyAppBanner?.addEventListener("click", removeStickyAppBanner);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (CfAppBanner_module_default()).appBannerWrapper,
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (CfAppBanner_module_default()).appBanner,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (CfAppBanner_module_default()).contentWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (CfAppBanner_module_default()).textBox,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: (CfAppBanner_module_default()).heading,
                                    children: "Download coursefinder.ai"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: (CfAppBanner_module_default()).description,
                                    children: [
                                        "One app for seamless student recruitment process. ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "Download the app to make your recruitment process quicker & smoother."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (CfAppBanner_module_default()).appLink,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://apps.apple.com/ph/app/coursefinder-ai/id6473614202",
                                            className: (CfAppBanner_module_default()).appStore,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: "https://assets.studies-overseas.com/apple_store_abb7e05cbc.png",
                                                width: 294,
                                                height: 86,
                                                alt: "Apple Store"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://play.google.com/store/apps/details?id=kc.coursefinder.ai",
                                            className: (CfAppBanner_module_default()).playStore,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: "https://assets.studies-overseas.com/play_store_78a6c36f3b.png",
                                                width: 294,
                                                height: 86,
                                                alt: "Play Store"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (CfAppBanner_module_default()).appImage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: "https://assets.studies-overseas.com/coursefinder_7beb6794c4.png",
                                width: 630,
                                height: 740,
                                alt: "CF App Banner"
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var CfAppBanner_CfAppBanner = (CfAppBanner);

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
;// CONCATENATED MODULE: ./components/ServicesForPartner.tsx





















const ServicesForPartnerPage = (props)=>{
    const sliderRef = (0,react.useRef)(null);
    const sliderSettings = {
        dots: true,
        dotsClass: (partnerServices_module_default()).sliderDots,
        className: "slider variable-width",
        infinite: true,
        speed: constants/* sliderSpeed.desktopSpeed */.Y$.desktopSpeed,
        variableWidth: true,
        centerMode: true,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3.5,
                    slidesToScroll: 3.5,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 976,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    initialSlide: 2,
                    variableWidth: false,
                    centerMode: false,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    variableWidth: false,
                    centerMode: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                    infinite: true,
                    dots: false,
                    speed: constants/* sliderSpeed.mobileSpeed */.Y$.mobileSpeed,
                    centerMode: false
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "servi-for-partner",
        className: (partnerServices_module_default()).partner,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (partnerServices_module_default()).curve,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `${(partnerServices_module_default()).contentDiv} ${(partnerServices_module_default()).breadcrum}`,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    xs: 12,
                                    lg: 6,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-block d-sm-none",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                    className: (partnerServices_module_default()).mobileBreadCrum,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                            style: {
                                                                opacity: 0.5
                                                            },
                                                            href: "/",
                                                            children: "Services"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                            href: "",
                                                            children: "For Partners"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: props.pageData.mainImageUrl || "/images/partners/partner1.svg",
                                                    alt: props.pageData.mainImageAltTag,
                                                    width: 375,
                                                    height: 424
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (partnerServices_module_default()).servContent,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                    className: "d-none d-sm-block",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                            href: "/",
                                                            style: {
                                                                opacity: 0.5
                                                            },
                                                            children: "Services"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                            href: "",
                                                            children: "For Partners"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    children: props?.pageData?.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: props?.pageData?.description
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (partnerServices_module_default()).buttons,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: `${(partnerServices_module_default()).CourseFinder} ${(0,helpers/* isFrappeOrJotFormClass */.gd)(props?.pageData?.meta?.jotforms[0]?.jotformid)}`,
                                                            children: "Partner With Us"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: `${(partnerServices_module_default()).Callback} ${(0,helpers/* isFrappeOrJotFormClass */.gd)(props?.pageData?.meta?.jotforms[1]?.jotformid)}`,
                                                            children: "Enquire Now"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    lg: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-none d-sm-block text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: props.pageData.mainImageUrl || "/images/partners/partner1.svg",
                                            alt: props.pageData.mainImageAltTag,
                                            width: 513,
                                            height: 424
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (partnerServices_module_default()).WhyKc,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (partnerServices_module_default()).customContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Why Partner with KC Overseas?"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: props?.pageData?.whyKc?.length > 0 && props?.pageData?.whyKc.map((kcBenefit)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xl: 4,
                                        md: 4,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-center mb-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (partnerServices_module_default()).circle,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: kcBenefit?.imagePath,
                                                        alt: kcBenefit?.ImageAltTag,
                                                        width: 40,
                                                        height: 40
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: kcBenefit?.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: kcBenefit?.description
                                                })
                                            ]
                                        })
                                    });
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (partnerServices_module_default()).countryFlags,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: props?.pageData?.countryFlag?.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: props?.pageData?.countryFlag?.shortDescription
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (partnerServices_module_default()).countryFlagSlider,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                        ...sliderSettings,
                        ref: sliderRef,
                        children: props?.pageData?.countryFlag?.flags?.length > 0 && props?.pageData?.countryFlag?.flags.map((image, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    image?.url && image.url.trim() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: image.url,
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (partnerServices_module_default()).sliderDiv,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: image?.imagePathUrl,
                                                alt: image?.imageAltTag,
                                                width: 232,
                                                height: 116,
                                                objectFit: "contain"
                                            })
                                        }, index)
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (partnerServices_module_default()).sliderDiv,
                                        style: {
                                            cursor: "default"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: image?.imagePathUrl,
                                            alt: image?.imageAltTag,
                                            width: 232,
                                            height: 116,
                                            objectFit: "contain"
                                        })
                                    }, index),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: image.name
                                    })
                                ]
                            });
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (partnerServices_module_default()).arrowsClass,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (partnerServices_module_default()).btcircle,
                                onClick: ()=>sliderRef?.current?.slickPrev(),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: "/new-images/left-arrow.svg",
                                    height: 17,
                                    width: 10,
                                    alt: "left-arrow"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (partnerServices_module_default()).btcircle,
                                onClick: ()=>sliderRef?.current?.slickNext(),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: "/new-images/right-arrow.svg",
                                    height: 17,
                                    width: 10,
                                    alt: "right-arrow"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (partnerServices_module_default()).TechCapabilities,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (partnerServices_module_default()).customContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Technological Capabilities"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (partnerServices_module_default()).CourseFinder,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (partnerServices_module_default()).TechCabMarBott,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: `${(partnerServices_module_default()).displayFlexReverseCourseFinder} ${(partnerServices_module_default()).marginBottomCf} ${(partnerServices_module_default()).displayFlex}`,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (partnerServices_module_default()).childFlex,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (partnerServices_module_default()).CourseFinderContent,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "d-block d-sm-none",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (partnerServices_module_default()).platformDivImg,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                            src: props?.pageData?.courseFinder[0].imagePath,
                                                                            alt: props?.pageData?.courseFinder[0].imageAltTag,
                                                                            width: 333.98,
                                                                            height: 279.13
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    children: props?.pageData?.courseFinder[0].title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: props?.pageData?.courseFinder[0].description
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                    className: "pl-0",
                                                                    children: props?.pageData?.courseFinder[0].points.map((point)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                                    children: point.title
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    children: point.description
                                                                                })
                                                                            ]
                                                                        }))
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "https://www.coursefinder.ai",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        target: "_blank",
                                                                        className: (partnerServices_module_default()).viewMore,
                                                                        children: "Go to coursefinder.ai"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (partnerServices_module_default()).childFlex,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: " d-none d-sm-block",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (partnerServices_module_default()).platformDivImg,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                    src: props?.pageData?.courseFinder[0].imagePath,
                                                                    alt: props?.pageData?.courseFinder[0].imageAltTag,
                                                                    width: 579,
                                                                    height: 547
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (partnerServices_module_default()).CourseFinder,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (partnerServices_module_default()).TechCabMarBott,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (partnerServices_module_default()).displayFlex,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (partnerServices_module_default()).childFlex,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "d-none d-sm-block",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: `${(partnerServices_module_default()).platformDivImg} ${(partnerServices_module_default()).ipadImgMb}`,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                    src: props?.pageData?.elanLoans[0].imagePath,
                                                                    alt: props?.pageData?.elanLoans[0].imageAltTag,
                                                                    width: 579,
                                                                    height: 547
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (partnerServices_module_default()).childFlex,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (partnerServices_module_default()).CourseFinderContent,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "d-block d-sm-none",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: `${(partnerServices_module_default()).platformDivImg} ${(partnerServices_module_default()).monbileImgMb}`,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                            src: props?.pageData?.elanLoans[0].imagePath,
                                                                            alt: props?.pageData?.elanLoans[0].imageAltTag,
                                                                            width: 333.98,
                                                                            height: 279.13
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    children: props?.pageData?.elanLoans[0].title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: props?.pageData?.elanLoans[0].description
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                    className: "pl-0",
                                                                    children: props?.pageData?.elanLoans[0].points.map((point)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                                    children: point.title
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    children: point.description
                                                                                })
                                                                            ]
                                                                        }))
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "https://www.elanloans.com/",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        target: "_blank",
                                                                        className: (partnerServices_module_default()).viewMore,
                                                                        children: "Go to Elan Loans"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (partnerServices_module_default()).TechCap,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (partnerServices_module_default()).TechCabMarBott,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (partnerServices_module_default()).customContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: "Your Business is our Top Priority"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: `${(partnerServices_module_default()).topPriority} ${(partnerServices_module_default()).displayFlex}`,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (partnerServices_module_default()).childFlex,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-block d-sm-none",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: `${(partnerServices_module_default()).platformDivImg} ${(partnerServices_module_default()).platformDivImgMobile}`,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: props?.pageData?.topPriority?.imagePath,
                                                                alt: props?.pageData?.topPriority?.imageAltTag,
                                                                width: 333,
                                                                height: 279
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: " d-none d-sm-block",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: `${(partnerServices_module_default()).commission} ${(partnerServices_module_default()).ipadImgMb}`,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: props?.pageData?.topPriority?.imagePath,
                                                                alt: props?.pageData?.topPriority?.imageAltTag,
                                                                width: 579,
                                                                height: 547
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (partnerServices_module_default()).childFlex,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (partnerServices_module_default()).commissionsContent,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: (partnerServices_module_default()).subHeadStyle,
                                                            children: props?.pageData?.topPriority?.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (partnerServices_module_default()).subHeadParat,
                                                            children: props?.pageData?.topPriority?.description
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            className: "pl-0",
                                                            children: props?.pageData?.topPriority?.points?.length > 0 && props?.pageData?.topPriority?.points.map((point, index)=>{
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                    className: (partnerServices_module_default()).subHeadUlLi,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                            children: point.title
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: point.description
                                                                        })
                                                                    ]
                                                                }, index);
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: `${(partnerServices_module_default()).empoweringYoumb} ${(partnerServices_module_default()).displayFlexReverse} ${(partnerServices_module_default()).displayFlex}`,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (partnerServices_module_default()).childFlex,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (partnerServices_module_default()).EmpoweringYou,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "d-block d-sm-none",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: `${(partnerServices_module_default()).platformDivImg} ${(partnerServices_module_default()).platformDivImgMobile}`,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                    src: props?.pageData?.EmpoweringYou?.imagePath,
                                                                    alt: props?.pageData?.EmpoweringYou?.imagePathAltTag,
                                                                    width: 333,
                                                                    height: 279
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (partnerServices_module_default()).EmpoweringYouContent,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    className: "mb-4",
                                                                    children: props?.pageData?.EmpoweringYou?.title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: props?.pageData?.EmpoweringYou?.description
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                    className: "pl-0",
                                                                    children: props?.pageData?.EmpoweringYou.points.map((point)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                                    children: point.title
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    children: point.description
                                                                                })
                                                                            ]
                                                                        }))
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (partnerServices_module_default()).childFlex,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: " d-none d-sm-block",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: `${(partnerServices_module_default()).platformDivImg} ${(partnerServices_module_default()).ipadImgMb}`,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: props?.pageData?.EmpoweringYou?.imagePath,
                                                            alt: props?.pageData?.EmpoweringYou?.imagePathAltTag,
                                                            width: 579,
                                                            height: 547
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (partnerServices_module_default()).TechCabMarBott,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (partnerServices_module_default()).displayFlex,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (partnerServices_module_default()).childFlex,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: " d-none d-sm-block",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: `${(partnerServices_module_default()).platformDivImg} ${(partnerServices_module_default()).ipadImgMb}`,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: props?.pageData?.AteamYourUnderstandsYourNeeds?.imagePath,
                                                    alt: props?.pageData?.AteamYourUnderstandsYourNeeds?.alt,
                                                    width: 579,
                                                    height: 547
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (partnerServices_module_default()).childFlex,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (partnerServices_module_default()).EmpoweringYou,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "d-block d-sm-none",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (partnerServices_module_default()).platformDivImg,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: props?.pageData?.AteamYourUnderstandsYourNeeds?.imagePath,
                                                            alt: props?.pageData?.AteamYourUnderstandsYourNeeds?.alt,
                                                            width: 333,
                                                            height: 279
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (partnerServices_module_default()).EmpoweringYouContent,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                            children: [
                                                                " ",
                                                                props?.pageData?.AteamYourUnderstandsYourNeeds?.title,
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: props?.pageData?.AteamYourUnderstandsYourNeeds?.description
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                            className: "pl-0",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                            children: "End-to-End Assistance"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "Comprehensive assistance for applications, financials, verifications, interviews & visas"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                            children: "Regional Managers"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "A team of industry professionals is ready to support you instantly with any of your queries"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                            children: "Multiple channels of communication"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "Emails, WhatsApp Chats, Calls, or Comments in the coursefinder.ai - Reach us through your preferred communication channel, as we are always listening."
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (partnerServices_module_default()).ThreeSteps,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (partnerServices_module_default()).studentFooter,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (partnerServices_module_default()).session,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                lg: 7,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (partnerServices_module_default()).text,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: "Partner with us to drive your business faster & reach your goals sooner"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                lg: 5,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (partnerServices_module_default()).anchor,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: `${(partnerServices_module_default()).reqCall} ${(0,helpers/* isFrappeOrJotFormClass */.gd)(props?.pageData?.meta?.jotforms[1]?.jotformid)}`,
                                                            children: "Enquire Now"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: `${(partnerServices_module_default()).partnerBtn} ${(0,helpers/* isFrappeOrJotFormClass */.gd)(props?.pageData?.meta?.jotforms[0]?.jotformid)}`,
                                                            children: "Partner With Us"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (partnerServices_module_default()).customContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CfAppBanner_CfAppBanner, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (partnerServices_module_default()).partnerUniTie,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UniTieUp["default"], {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonial/* default */.Z, {
                title: "Our partners love us",
                bgColor: "#ffffff",
                slug: `testimonials?type=partner&_limit=15&_sort=id:DESC`
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (partnerServices_module_default()).achievements,
                children: props.pageData?.videoTestimonial && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoTestimonials/* default */.Z, {
                    ...props.pageData.videoTestimonial
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (partnerServices_module_default()).partnerWebinarEvent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedPartnerWebinars/* default */.Z, {
                    title: "Webinars for Partners"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (partnerServices_module_default()).partnerRecognitions,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Recognition/* default */.Z, {
                    bgColor: "#B8AAEE"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (partnerServices_module_default()).partnerKcUpdates,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(kcNewlatestupdates["default"], {
                    ...props
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (partnerServices_module_default()).partnerBlogs,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedBlogs["default"], {})
            }),
            props.pageData?.faq && /*#__PURE__*/ (0,jsx_runtime.jsx)(FrequentlyAskedQuestions/* default */.Z, {
                ...props.pageData.faq
            })
        ]
    });
};
/* harmony default export */ var ServicesForPartner = (ServicesForPartnerPage);

;// CONCATENATED MODULE: ./pages/partners/study-abroad-association.tsx




const StudyAbraodAssociation = (props)=>{
    const { meta  } = props?.pageData;
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#226CF5");
        customStyle.setProperty("--navbar-menu-color", "#ffff");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            meta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...meta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesForPartner, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var study_abroad_association = (StudyAbraodAssociation);


/***/ }),

/***/ 62154:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"appBannerWrapper":"CfAppBanner_appBannerWrapper__UZbvA","appBanner":"CfAppBanner_appBanner__EEENa","contentWrapper":"CfAppBanner_contentWrapper__9XXmh","textBox":"CfAppBanner_textBox__wU3G3","heading":"CfAppBanner_heading__aeCFT","description":"CfAppBanner_description___u4RA","appLink":"CfAppBanner_appLink__RVngp","appStore":"CfAppBanner_appStore__poPUc","playStore":"CfAppBanner_playStore__HGpcW","appImage":"CfAppBanner_appImage__bqGxx","stickyAppBanner":"CfAppBanner_stickyAppBanner__fFC96"};

/***/ }),

/***/ 52783:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"partner":"partnerServices_partner__f1CLL","curve":"partnerServices_curve__d6kb7","contentDiv":"partnerServices_contentDiv__sQJlk","buttons":"partnerServices_buttons__3iiya","CourseFinder":"partnerServices_CourseFinder__8wvdt","Callback":"partnerServices_Callback__iT4zZ","WhyKc":"partnerServices_WhyKc__pcrCt","circle":"partnerServices_circle__aCfhI","viewMore":"partnerServices_viewMore__h64pf","whyMb":"partnerServices_whyMb__QNBKc","countryFlags":"partnerServices_countryFlags__bth3k","countryFlagSlider":"partnerServices_countryFlagSlider__fX8GW","sliderDiv":"partnerServices_sliderDiv__wE2_B","arrowsClass":"partnerServices_arrowsClass__sWLve","card":"partnerServices_card__1kR2v","cardBody":"partnerServices_cardBody__yhS3E","sliderDots":"partnerServices_sliderDots__MbcMu","TechCapabilities":"partnerServices_TechCapabilities__l0PAB","tabs":"partnerServices_tabs__zBwlu","displayFlex":"partnerServices_displayFlex__NnaKh","childFlex":"partnerServices_childFlex__gqCsg","CourseFinderContent":"partnerServices_CourseFinderContent__lGsBb","EmpoweringYouContent":"partnerServices_EmpoweringYouContent__3P715","EmpoweringYou":"partnerServices_EmpoweringYou__aUdUj","TechCabMarBott":"partnerServices_TechCabMarBott__TC5ib","marginBottomCf":"partnerServices_marginBottomCf__2Z4es","displayFlexReverseCourseFinder":"partnerServices_displayFlexReverseCourseFinder__YVVQZ","empoweringYoumb":"partnerServices_empoweringYoumb__p9wT0","TechCap":"partnerServices_TechCap__5VzSD","topPriority":"partnerServices_topPriority__jXhns","displayFlexReverse":"partnerServices_displayFlexReverse__q_O8_","ThreeSteps":"partnerServices_ThreeSteps___fpRX","revenues":"partnerServices_revenues__9DRpj","steps":"partnerServices_steps___4XcJ","stepsDiv":"partnerServices_stepsDiv__z6RWq","studentFooter":"partnerServices_studentFooter__wySqd","session":"partnerServices_session__kil2P","text":"partnerServices_text__6Wjy8","partnerBtn":"partnerServices_partnerBtn__u5jfN","reqCall":"partnerServices_reqCall___WzHV","anchor":"partnerServices_anchor__pDFB2","partnerSlider":"partnerServices_partnerSlider__x1BUD","partnerCard":"partnerServices_partnerCard__7LtaK","middelStuTest":"partnerServices_middelStuTest__IaKq6","uniTieUp":"partnerServices_uniTieUp__9dSuO","cols":"partnerServices_cols__C6QPl","borderl0":"partnerServices_borderl0__ZdALU","border0":"partnerServices_border0__cZxfl","partnerRecognitions":"partnerServices_partnerRecognitions__FvtO9","recongnition":"partnerServices_recongnition__KO5i2","partnerKcUpdates":"partnerServices_partnerKcUpdates__WA3hK","partnerBlogs":"partnerServices_partnerBlogs__znZFX","partnerTestimonials":"partnerServices_partnerTestimonials__0Jm6I","achievements":"partnerServices_achievements__RJ2BA","btcircle":"partnerServices_btcircle__Q4dLa","customContainer":"partnerServices_customContainer__yLgim","ipadImgMb":"partnerServices_ipadImgMb__JWXTw","platformDivImgMobile":"partnerServices_platformDivImgMobile__ZGuHe","platformDivImg":"partnerServices_platformDivImg__Zkt01","partnerUniTie":"partnerServices_partnerUniTie__YbZWa"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,9882,3656,4706,474,5684,9465,3593,2995,3752,9774,2888,179], function() { return __webpack_exec__(84344); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);